// Helper function that will appropriately capitalize Resume and CV in an email
export default function (productName: 'Resume' | 'CV'): string {
  return productName === 'Resume' ? productName.toLowerCase() : productName
}
